export const API_ACCESS_TOKEN = 'alloyCarbonAccessToken'
export const CSRF_TOKEN = 'alloyCarbonCsurfToken'
export const LANGUAGE_KEY = 'alloyCarbonLanguage'
export const UK_COUNTRY_ID = 248
